import React, { useState, useRef } from "react"
import { useTranslation } from "react-i18next"

import { Input } from "components"
import classes from "./index.module.scss"

const NcoHeader = (props) => {
  const { setOrderCode } = props

  const [t] = useTranslation()

  const [input, setInput] = useState("")

  const timeout = useRef(false)

  const handleChangeOrderCode = e => {
    const value = e.target.value

    setInput(value)

    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(() => {
        setOrderCode(value)
      }, 600)
  }

  return (
    <div className={classes["row"]}>
      <Input
        value={input}
        className={classes["input"]}
        placeholder={t("جست_و_جو_سفارشات_با_کد")}
        onChange={handleChangeOrderCode}
      />
    </div>
  )
}

export default NcoHeader